const reviewOrder = 'Review your order';

const header = (page, title, backIcon = true) => ({ page, title, backIcon });

export const pageHeaders = [
  header('progressiveplan', 'Progressive Plan'),
  header('streamlineordering', 'Streamline Ordering'),
  header('addons', 'Enhance your service'),
  header('setup', 'Setup options'),
  header('cart', 'Cart Details'),
  header('contactinfo', 'Contact Information'),
  header('createprofile', 'Create Profile'),
  header('shipping', 'Shipping Information'),
  header('expresscheckout', reviewOrder),
  header('orderreview', reviewOrder),
  header('expresstos', 'Review your agreements and complete your order'),
  header('payment', 'Payment Details'),
  header('creditcheck', 'Credit Check'),
  header('creditstatus', 'Credit status', false),
  header('appointment', 'Appointment Details'),
  header('popularplan', 'Popular Plan'),
];
